//Dependecies
import React from 'react';

const StatTile = (props) => {
  return (
    <div className='flex flex-col items-start p-6 bg-white border border-[#DCDCDC] gap-5 shadow-sm w-full h-[200px] min-h-[200px]' id='statTile'>
        <div className='flex flex-col items-start gap-1' id='tileHeader'>
            <h2 className='text-xl font-bold'>{props.tileHeaderText}</h2>
            <p className='text-sm font-normal'>{props.tileDescription}</p>
        </div>
        <h2 className='text-3xl font-black'>{props.tileStat}</h2>
    </div>
  );
}

export default StatTile;
